/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { types } from 'mobx-state-tree';

export default types.model({
	badgesInfo: types.frozen(),
	isOpen: types.boolean,
	position: types.frozen()
}).views((self) => ({
	getPosition() {
		return self.position;
	},
	isTooltipOpen() {
		return self.isOpen;
	},
	getBadgesInfo() {
		return self.badgesInfo;
	}
})).actions(self => ({
	closeTooltip() {
		self.isOpen = false;
	},
	openTooltip(position) {
		self.isOpen = true;
		self.position = position;
	},
	setBadgesInfo(badgesInfo) {
		self.badgesInfo = badgesInfo;
	}
}));



// WEBPACK FOOTER //
// ./src/js/features/badges/BadgeTooltipModel.js